export default __webpack_public_path__ + "static/media/Cordia New Bold.f9e757dd.ttf";